import React from 'react';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1
  }
};

const Mydetails: React.FC = () => {
  return (
    <div className=" md:py-20 px-4 md:px-8 bg-black">
      <div className="max-w-4xl md:max-w-7xl mx-auto">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          {/* Main heading */}
          <motion.h1 
            className="text-lg font-medium leading-[2rem] text-left mb-12 md:text-4xl md:font-medium md:leading-[3rem] md:max-w-6xl md:mb-12 md:text-left"
            variants={itemVariants}
          >
           A showcase of projects I've designed and built — blending creativity with code to deliver user-focused digital experiences. From prototypes to live platforms, each project highlights my skills in UI/UX design and frontend development using tools like Figma and React.


          </motion.h1>
        </motion.div>
      </div>
    </div>
  );
};

export default Mydetails;